import { render } from "./Languages.vue?vue&type=template&id=8ced8952&scoped=true&ts=true"
import script from "./Languages.vue?vue&type=script&lang=ts"
export * from "./Languages.vue?vue&type=script&lang=ts"

import "./Languages.vue?vue&type=style&index=0&id=8ced8952&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ced8952"]])

export default __exports__